import { LotteryTaskStatuses, LotteryTask } from "./task.model";

export class TaskQueue {
    Email: string;
    BetId: string;
    LotteryId: string;
    TaskId:string;
    status: number;
    id:string;
    description: string;
    createDate: number;
    forceFinish: boolean;
    UserId: any;
    action: number;
    ownerTask: LotteryTask;
}

export class LotteryDrawTask {

    lotteryId: string;
    status: number;
    id:string;
    createDate: number;
    data: any;
    reportType : string;
}